import useCampaign from '@hooks/useCampaign'
import useConversationContainer from '@hooks/useConversationContainer'
import useOrderItem from '@hooks/useOrderItem'

import formatDate from '@functions/formatDate'
import { stringHasContent } from '@functions/utility'

type UseAdCopyReviewModalParams = {
  adCopyId: number,
  campaignId: number,
  orderItemId?: number,
}
const useAdCopyReviewRequestsModal = (params: UseAdCopyReviewModalParams) => {
  const { adCopyId, campaignId, orderItemId } = params

  const { orderItem, service } = useOrderItem({ id: orderItemId })
  const { campaign } = useCampaign({ id: campaignId }, { performHttpRequests: !!campaignId })

  const conversationPayload = useConversationContainer({
    // @ts-expect-error TS2739
    conversation: {
      subject_type: 'AdCopy',
      subject_id: adCopyId,
      campaign_id: campaign?.id,
      agency_id: campaign.agency_id,
    },
  })

  const {
    filteredComments, hasFilteredComments,
  } = conversationPayload

  const descendingFilteredComments = filteredComments.sort((a, b) => (b.id - a.id))

  // @ts-expect-error TS2339
  const latestCommentDateString = descendingFilteredComments[0]?.dates?.created?.date_time ?? ''
  const latestCommentDate = stringHasContent(latestCommentDateString)
    ? formatDate(latestCommentDateString, 'dd/MM/yyyy HH:mm') : ''

  return {
    campaign,
    descendingFilteredComments,
    hasFilteredComments,
    latestCommentDate,
    orderItem,
    service,
  }
}

export default useAdCopyReviewRequestsModal
